import React, { useCallback, useEffect, useState } from 'react';
import PageHeader from '../components/PageHeader';
import { adminApi } from '../../services/api';

const Refunds = () => {
  const [requests, setRequests] = useState([]);
  const [status, setStatus] = useState('all');
  const [message, setMessage] = useState('');

  const loadRefunds = useCallback(() => {
    adminApi.listReturns(status === 'all' ? {} : { status })
      .then((response) => setRequests(response.data?.data || []))
      .catch(() => setRequests([]));
  }, [status]);

  useEffect(() => {
    loadRefunds();
  }, [loadRefunds]);

  const updateRefund = async (id, nextStatus) => {
    setMessage('');
    try {
      await adminApi.updateReturn(id, { status: nextStatus, adminNote: nextStatus === 'approved' ? 'Refund approved by admin' : `Refund marked ${nextStatus}` });
      setMessage(`Refund ${nextStatus}.`);
      loadRefunds();
    } catch (error) {
      setMessage(error.response?.data?.message || 'Could not update refund.');
    }
  };

  return (
    <div className="space-y-6">
      <PageHeader title="Refund Requests" description="Approve, reject, and mark refunds as processed" breadcrumbs={['Home', 'Refunds']} />
      <div className="bg-white rounded-xl border border-gray-100 p-4 flex flex-wrap gap-2">
        {['all', 'requested', 'approved', 'rejected', 'refunded'].map((item) => (
          <button key={item} onClick={() => setStatus(item)} className={`px-4 py-2 rounded-lg text-sm font-semibold ${status === item ? 'bg-amber-600 text-white' : 'bg-gray-100 text-gray-700'}`}>
            {item.charAt(0).toUpperCase() + item.slice(1)}
          </button>
        ))}
      </div>
      {message && <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 text-sm text-amber-700">{message}</div>}
      <div className="space-y-4">
        {requests.map((request) => (
          <div key={request._id} className="bg-white rounded-xl border border-gray-100 p-5">
            <div className="flex flex-wrap justify-between gap-4">
              <div>
                <p className="font-semibold text-gray-900">Order {request.orderId?._id || request.orderId}</p>
                <p className="text-sm text-gray-600">{request.userId?.name} - {request.userId?.email}</p>
                <p className="text-sm text-gray-700 mt-2">Reason: {request.reason}</p>
              </div>
              <div className="text-right">
                <span className="inline-block px-3 py-1 rounded-full bg-yellow-100 text-yellow-700 text-xs font-semibold">{request.status}</span>
                <p className="font-bold mt-2">Rs. {Number(request.orderId?.totalAmount || 0).toLocaleString('en-IN')}</p>
              </div>
            </div>
            <div className="mt-4 flex flex-wrap gap-2">
              <button onClick={() => updateRefund(request._id, 'approved')} className="px-4 py-2 rounded-lg bg-green-100 text-green-700 text-sm font-semibold">Approve</button>
              <button onClick={() => updateRefund(request._id, 'rejected')} className="px-4 py-2 rounded-lg bg-red-100 text-red-700 text-sm font-semibold">Reject</button>
              <button onClick={() => updateRefund(request._id, 'refunded')} className="px-4 py-2 rounded-lg bg-blue-100 text-blue-700 text-sm font-semibold">Mark Refunded</button>
            </div>
          </div>
        ))}
        {requests.length === 0 && <div className="bg-white rounded-xl border border-gray-100 p-8 text-center text-gray-600">No refund requests found.</div>}
      </div>
    </div>
  );
};

export default Refunds;
